export function useCleanMask(value) {
    var curency = '$';
    var sepMiles = '\.';
    var space = ' ';


    var regExp = new RegExp("[" + curency + sepMiles + space + "]", "g");
    return value.replace(regExp, "");
}
